module.exports = __webpack_public_path__ + "static/cloud-engineers-2-de792683f3544659a8a8ffd5417443ee.svg";